import { Col, Row } from "react-bootstrap";
import styled from "styled-components";

import { SectorAllocationContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { Title } from "style/components/Title.styles";
import { Placeholder } from "components/Placeholder";

const SectorAllocationPlaceholderContainer = styled.div`
  .placeholder-glow {
    width: 100%;
  }

  .dot-wrapper .placeholder-glow {
    width: auto;
  }
`;

const SectorAllocationPlaceholder = () => {
  return (
    <SectorAllocationPlaceholderContainer>
      <SectorAllocationContainer>
        <Title>Sector Allocation</Title>

        <div className="line-wrapper">
          <Placeholder as="div" className="line" />
        </div>

        {Array.from({ length: 3 }, (_, inx) => (
          <Row className="list-wrapper" key={inx}>
            <Col md={9} lg={10} xs={10} className="label">
              <div className="dot-wrapper">
                <Placeholder as="div" className="dot" col={{ lg: 2, xs: 2 }} />
              </div>
              <Placeholder as="span" col={{ lg: 12, xs: 8 }} />
            </Col>
            <Col md={3} lg={2} xs={2} className="value">
              <Placeholder as="span" col={{ lg: 12, xs: 12 }} />
            </Col>
          </Row>
        ))}
      </SectorAllocationContainer>
    </SectorAllocationPlaceholderContainer>
  );
};

export default SectorAllocationPlaceholder;
